export default "__VITE_ASSET__ChOQn5KC__"